<template>
  <div>
    <div class="chart-holder-line" style="color: #000;">
      <bar-chart
        :data="specialty"
        :colors="colors"
        height="300px"
        width="100%"
        :library="options"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import AdminClient from '@/api/AdminClient';

Vue.use(Chartkick.use(Chart));

export default {
  name: 'CounselorBySpecialty',
  data() {
    return {
      adminClient: new AdminClient(this.$http),
      selected: '',
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontColor: '#f5f5f5'
            },
            gridLines: {
              color: '#808080'
            }
          }],
          yAxes: [{
            ticks: {
              fontColor: '#f5f5f5',
            },
          }]
        }
      },
      colors: [
        '#4cf2f0',
        '#FFBA49',
        '#B5446E',
        '#F4743B',
        '#16697A',
        '#1f8992',
        '#f5f5f5'
      ],
    }
  },
    asyncComputed:{
      async counselorSpecialty() {
        const response = await this.adminClient.getCounselorSpecialty()
        if (!response || !response.results) return []
        return response.results
      }
    },
    computed: {
      specialty() {
        if (!this.counselorSpecialty) return []
        let demo = []
        demo = this.aggregate_session_total_array(this.counselorSpecialty[0])
        if (!demo) return []
        return this.capitaplize_keys_for_chart(demo)
      }
    },
    methods: {
      aggregate_session_total_array(obj) {
        const agg = Object.entries(obj)
        return agg;
      },
      capitaplize_keys_for_chart(specialty) {
        const capitalized = []
        for (let i = 0;i < specialty.length; i++) {
            const newArr = []
            const title = specialty[i][0]

            const str = title.split('_').join(' ');
            const uppercaseWords = str.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());

            newArr.push(uppercaseWords, specialty[i][1])
            capitalized.push(newArr)
        }

        return capitalized
      }
  }
}
</script>
<style lang="scss" scoped>

.chart-holder-line {
    position: relative;
    left: -15px;
    width: calc(100% + 15px);
    min-height: 150px;
  }

</style>
